import { Grid, Card, MenuItem, FormControl, Box, CircularProgress, Backdrop } from "@mui/material";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout/index.js";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar/index.js";
import DataTable from "layouts/Tables/DataTable";
import { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import axios from "axios";
import { toast } from 'react-toastify';
import { useTranslation } from "react-i18next";
import { handleErrors } from "common.js";
import { useMaterialUIController, setTicketContext } from "context";
import configurationContext from "contextConfig";
import Link from '@mui/material/Link';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Config from "../../config.js";
import { VENDOR_TICKET } from 'constants';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';


function ManageTickets(props) {
  const type = props.props.type;
  const navigate = useNavigate();
  const { pageNo } = useParams();
  var pageSelected = 1;
  const MyContext = useContext(configurationContext);
  const [controller, dispatch, initialState] = useMaterialUIController();
  const { ticketContext } = controller;
  if (typeof pageNo !== "undefined") {
    const parts = pageNo.split("-");
    pageSelected = parts[1].trim();
  }
  const { t } = useTranslation();
  const BASE = Config.BASE;
  const TOKEN = window.localStorage.getItem('token');
  const [ticketData, setData] = useState({});
  const [responseResultCount, setResponseResultCount] = useState(0);
  const searchFilterData = { 'status': ticketContext.status, 'vendorShopName': ticketContext.vendorShopName, 'searchBy': ticketContext.searchBy, 'customerEmail': ticketContext.customerEmail };
  const [isLoading, setIsLoading] = useState(true);
  const [isTicketContextChanged, setTicketContextChanged] = useState(false);

  const data = () => {
    setIsLoading(true);
    toast.dismiss();
    let queryParams = new URLSearchParams(searchFilterData).toString();
    queryParams = queryParams + "&pageSelected=" + pageSelected;
    axios({
      url: BASE + "api/ticket/list-" + type + "-tickets?" + queryParams,
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      }
    }).then(function (response) {
      setIsLoading(false);
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          setData(response.data);
          if (response.data.data && response.data.data.totalCount) {
            setResponseResultCount(response.data.data.totalCount);
          }
        }
        else {
          toast.error(t(message));
        }
      } else {
        toast.error(t('unableToProccessRequest'));
      }

    }).catch(function (error) {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  }

  useEffect(() => {
    data();
  }, [pageNo, type]);

  const handleResetFilters = () => {
    setTicketContext(dispatch, initialState.ticketContext);
    setTicketContextChanged(false);
    if (typeof pageNo === "undefined")
      navigate("/tickets/" + type + "Ticket/page-1");
    else
      navigate("/tickets/" + type + "Ticket");
  };

  useEffect(() => {
    const hasChanged = Object.keys(ticketContext).some(
      key => ticketContext[key] !== initialState.ticketContext[key]
    );
    setTicketContextChanged(hasChanged);
  }, [ticketContext]);

  const columns = [
    { Header: t('Id'), accessor: "id", align: "left" },
    { Header: t('shopName'), accessor: "shopName", align: "left" },
    { Header: t('subject'), accessor: "subject", align: "left" },
    { Header: t("status"), accessor: "status", align: "left" },
    { Header: t("dataTime"), accessor: "date", align: "left" },
    { Header: t("action"), accessor: "action", align: "left" }
  ];

  const dynamicColumns = type === 'customer' ? columns.filter(column => column.accessor !== 'shopName') : columns;

  const finalObj = [];
  if (ticketData.data && ticketData.data.rows) {
    let ticketRecords = ticketData.data.rows;
    for (const rowKey in ticketRecords) {
      let ticketRecord = ticketRecords[rowKey];
      if (ticketRecord.id > 0) {
        let tempObj = {
          id: '#' + ticketRecord.id,
          shopName: ticketRecord.name + ' (' + ticketRecord.shopName + ')',
          subject:
            <MDTypography component="a"
              href={"#"}
              onClick={(event) => { event.preventDefault(); navigate("/tickets/view" + type + "Ticket/" + ticketRecord.id) }}
              variant="caption" color="text" fontWeight="medium">
              {ticketRecord.subject.substring(0, 50)}
            </MDTypography>,
          status: <span className={'statusD' + ticketRecord.status}>
            {
              (ticketRecord.status == VENDOR_TICKET.AWAITING_ADMIN_REPLY) ? <span>{t('awaitingAdminReply')}</span> :
                (ticketRecord.status == VENDOR_TICKET.CLOSED) ? <span>{t('closed')}</span> :
                  (ticketRecord.status == VENDOR_TICKET.AWAITING_VENDOR_REPLY) ? <span>{t('awaiting' + type + 'Reply')}</span> : null}</span>,
          date:
            <>
              <CalendarMonthIcon />{new Date(ticketRecord.createdAt).toLocaleDateString()}
              <span>{' , '}</span>
              <AccessTimeIcon />{new Date(ticketRecord.createdAt).toLocaleTimeString()}
            </>,
          action:
            <span className="actionClass">
              <Link href={"#"} className="view-link-ticket paddingRight5"
                onClick={(event) => { event.preventDefault(); navigate("/tickets/view" + type + "Ticket/" + ticketRecord.id) }}
              >
                <Box className="squareBoxView"><VisibilityIcon color="primary" fontSize="medium" titleAccess={t("view")} /></Box>
              </Link>
            </span>
        };
        finalObj.push(tempObj);
      }
    }
  }

  const rows = finalObj;

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={t(type + "Tickets")} />
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <MDBox pt={6} pb={3} >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Card className="ContentSectionBox">
              <MDBox className="ManageProductTopSec" mx={2} mt={0} py={3} px={2} variant="gradient" >
                <Grid container className="FilterSectionBox ManageProductContainer" spacing={2} >
                  <Grid item xs={12} sm={3} md={3}  >
                    <MDInput
                      select
                      name="status"
                      label={t('status')}
                      value={searchFilterData.status}
                      InputProps={{
                        classes: { root: "filterStyle" },
                      }}
                      className="ManageProductTopSecip"
                      onChange={(obj) => {
                        setTicketContext(dispatch, { ...ticketContext, status: obj.target.value });
                      }} fullWidth
                    >
                      <MenuItem value={'all'}>{t('All')}</MenuItem>
                      <MenuItem value={1}>{t('awaitingAdminReply')}</MenuItem>
                      <MenuItem value={2}>{t('awaiting' + type + 'Reply')}</MenuItem>
                      <MenuItem value={3}>{t('closed')}</MenuItem>
                    </MDInput>
                  </Grid>
                  {type == "vendor" ?
                    <>
                      <Grid item xs={12} sm={2} md={2}>
                        <MDInput
                          select
                          name="searchBy"
                          label={t('searchBy')}
                          value={searchFilterData.searchBy}
                          InputProps={{
                            classes: { root: "filterStyle" },
                          }}
                          onChange={(obj) => {
                            if (obj.target.value === 'none') {
                              setTicketContext(dispatch, { ...ticketContext, searchBy: obj.target.value, vendorShopName: '' });
                            }
                            else {
                              setTicketContext(dispatch, { ...ticketContext, searchBy: obj.target.value });
                            }
                          }} fullWidth
                        >
                          <MenuItem value={'none'}>{t('none')}</MenuItem>
                          <MenuItem value={'vendorShopName'}>{t('vendorShopName')}</MenuItem>
                        </MDInput>
                      </Grid>
                      {(ticketContext.searchBy === "vendorShopName") ?
                        <Grid item xs={12} sm={3} md={3} >
                          <FormControl >
                            <MDInput
                              key={'vendorShopName'}
                              value={ticketContext.vendorShopName}
                              InputProps={{
                                classes: { root: "filterStyle" },
                              }}
                              type="text" name="vendorShopName" label={t('searchInput')}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              onChange={(obj) => {
                                setTicketContext(dispatch, { ...ticketContext, vendorShopName: obj.target.value });
                              }} fullWidth />
                          </FormControl>
                        </Grid>
                        : null}
                    </>
                    :
                    <>
                      <Grid item xs={12} sm={2} md={2}>
                        <MDInput
                          select
                          name="searchBy"
                          label={t('filterBy')}
                          value={searchFilterData.searchBy}
                          InputProps={{
                            classes: { root: "filterStyle" },
                          }}
                          onChange={(obj) => {
                            if (obj.target.value === 'none') {
                              setTicketContext(dispatch, { ...ticketContext, searchBy: obj.target.value, customerEmail: '' });
                            }
                            else {
                              setTicketContext(dispatch, { ...ticketContext, searchBy: obj.target.value });
                            }
                          }} fullWidth
                        >
                          <MenuItem value={'none'}>{t('none')}</MenuItem>
                          <MenuItem value={'customerEmail'}>{t('customerEmail')}</MenuItem>
                        </MDInput>
                      </Grid>
                      {(ticketContext.searchBy === "customerEmail") ?
                        <Grid item xs={12} sm={3} md={3} >
                          <FormControl >
                            <MDInput
                              key={'customerEmail'}
                              value={ticketContext.customerEmail}
                              InputProps={{
                                classes: { root: "filterStyle" },
                              }}
                              type="text"
                              name="customerEmail"
                              label={t('searchInput')}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              onChange={(obj) => {
                                setTicketContext(dispatch, { ...ticketContext, customerEmail: obj.target.value });
                              }} fullWidth />
                          </FormControl>
                        </Grid>
                        : null}
                    </>
                  }
                  <Grid item xs={12} sm={2} md={2}>
                    <FormControl className="filterSubmit">
                      <MDButton
                        onClick={() => {
                          navigate("/tickets/" + type + "Ticket");
                          if (typeof pageNo === "undefined")
                            data();
                        }}
                        key="submit" type="submit" color="info" size="small" className="SubmitButton" disableRipple fullWidth> {t('submit')} </MDButton>
                      {isTicketContextChanged && (
                        <MDButton onClick={handleResetFilters} key="reset" type="submit" color="info" size="small" className="ResetButton" disableRipple fullWidth>{t('reset')}</MDButton>
                      )}
                    </FormControl>
                  </Grid>
                </Grid>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns: dynamicColumns, rows }}
                  isSorted={false}
                  showTotalEntries={true}
                  responseResultCount={responseResultCount}
                  paginationSize={MyContext.paginationSize}
                  paginationLink={"/tickets/" + type + "Ticket/page-"}
                  pageSelected={pageSelected}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default ManageTickets;
